// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"86635578","148":"8226694a","342":"f4d3a43f","569":"afcc6235","616":"77ab36e7","837":"ed6f7b02","863":"3a696c14","937":"add52849","951":"dcd0b84f"}[chunkId] + ".chunk.css";
};